import { distinctUntilChanged, map, switchMap, withLatestFrom } from "rxjs/operators";
import { EdgeDirection } from "../../graph/edge/EdgeDirection";
import { State } from "../../state/State";
import { HandlerBase } from "../../utils/HandlerBase";
/**
 * The `KeyPlayHandler` allows the user to control the play behavior
 * using the following key commands:
 *
 * `Spacebar`: Start or stop playing.
 * `SHIFT` + `D`: Switch direction.
 * `<`: Decrease speed.
 * `>`: Increase speed.
 *
 * @example
 * ```
 * var keyboardComponent = viewer.getComponent("keyboard");
 *
 * keyboardComponent.keyPlay.disable();
 * keyboardComponent.keyPlay.enable();
 *
 * var isEnabled = keyboardComponent.keyPlay.isEnabled;
 * ```
 */
export class KeyPlayHandler extends HandlerBase {
    _enable() {
        this._keyDownSubscription = this._container.keyboardService.keyDown$
            .pipe(withLatestFrom(this._navigator.playService.playing$, this._navigator.playService.direction$, this._navigator.playService.speed$, this._navigator.stateService.currentNode$.pipe(switchMap((node) => {
            return node.sequenceEdges$;
        })), this._navigator.stateService.state$.pipe(map((state) => {
            return state === State.Earth;
        }), distinctUntilChanged()), this._navigator.playService.bridge$))
            .subscribe(([event, playing, direction, speed, status, earth, bridge]) => {
            if (event.altKey || event.ctrlKey || event.metaKey) {
                return;
            }
            let newDirection = null;
            switch (event.key) {
                case "D":
                    if (!event.shiftKey) {
                        return;
                    }
                    newDirection = playing
                        ? null
                        : direction === EdgeDirection.Next
                            ? EdgeDirection.Prev
                            : direction === EdgeDirection.Prev
                                ? EdgeDirection.Next
                                : null;
                    if (newDirection != null) {
                        this._navigator.playService.setDirection(newDirection);
                    }
                    break;
                case " ":
                    if (event.shiftKey) {
                        return;
                    }
                    if (!earth) {
                        if (playing) {
                            this._navigator.playService.stop();
                        }
                        else {
                            let playeable = false;
                            for (const edge of status.edges) {
                                if (edge.data.direction === direction) {
                                    playeable = true;
                                }
                            }
                            if (playeable || bridge) {
                                this._navigator.playService.play();
                            }
                        }
                    }
                    break;
                case "<":
                    this._navigator.playService.setSpeed(speed - 0.05);
                    break;
                case ">":
                    this._navigator.playService.setSpeed(speed + 0.05);
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
    }
    _disable() {
        this._keyDownSubscription.unsubscribe();
    }
    _getConfiguration(enable) {
        return { keyZoom: enable };
    }
}
//# sourceMappingURL=KeyPlayHandler.js.map